// Armazenamento local do protótipo PWA. NÃO sincroniza com Google Drive.
// Um único espaço de testes por perfil do navegador; sem dados de saúde ou GPS.
const NAME='domus-self-family-local',VERSION=1,STORE='records'
const open=()=>new Promise((resolve,reject)=>{
 if(!('indexedDB' in window))return reject(Error('IndexedDB indisponível'))
 const request=indexedDB.open(NAME,VERSION)
 request.onupgradeneeded=()=>{const db=request.result;if(!db.objectStoreNames.contains(STORE))db.createObjectStore(STORE)}
 request.onsuccess=()=>resolve(request.result)
 request.onerror=()=>reject(request.error||Error('Erro de armazenamento'))
})
export const localGet=async key=>{
 const db=await open()
 return new Promise((resolve,reject)=>{const tx=db.transaction(STORE,'readonly');const r=tx.objectStore(STORE).get(key);r.onsuccess=()=>resolve(r.result??null);r.onerror=()=>reject(r.error);tx.oncomplete=()=>db.close();tx.onerror=()=>reject(tx.error)})
}
export const localSet=async(key,value)=>{
 const db=await open()
 return new Promise((resolve,reject)=>{const tx=db.transaction(STORE,'readwrite');tx.objectStore(STORE).put(value,key);tx.oncomplete=()=>{db.close();resolve(value)};tx.onerror=()=>{db.close();reject(tx.error)}})
}
export const localExport=async()=>{
 const db=await open()
 return new Promise((resolve,reject)=>{const data={format:'domus-local-v1',exported_at:new Date().toISOString(),records:{}}
 const tx=db.transaction(STORE,'readonly')
 const cursor=tx.objectStore(STORE).openCursor()
 cursor.onsuccess=()=>{const c=cursor.result;if(c){data.records[c.key]=c.value;c.continue()}}
 tx.oncomplete=()=>{db.close();resolve(data)}
 tx.onerror=()=>{db.close();reject(tx.error)}
 })
}
